import React, { Fragment, useMemo } from 'react'
import { Tooltip } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { isEmpty, trim } from 'lodash'
import { fetchGlobalBrowserVariable, GLOBAL_VAR_KEYS } from '../../../lib/globalUtils'

export const WebTooltip = React.memo(({ children, disableTooltip, title, ...rest }) => {
  const placement = useSelector((state) => state.getIn(['project', 'Settings', 'ui', 'tooltipPlacement'], 'top'))

  const isTitleEmpty = isEmpty(trim(title))
  const isAutoScaleZoomApplied = fetchGlobalBrowserVariable(GLOBAL_VAR_KEYS.AUTO_SCALE_ZOOM)

  const popperProps = useMemo(
    () => ({
      style: !isTitleEmpty
        ? { zIndex: 1600 }
        : {
            display: 'none',
          },
      disablePortal: isAutoScaleZoomApplied,
    }),
    [title]
  )

  if (disableTooltip) {
    return children
  }

  return (
    <Tooltip
      enterTouchDelay={200}
      enterDelay={200}
      title={title ? title : ''}
      PopperProps={popperProps}
      {...rest}
      placement={placement}>
      {children}
    </Tooltip>
  )
})
